import { render, staticRenderFns } from "./langSwitch.vue?vue&type=template&id=f7c264b4&"
import script from "./langSwitch.vue?vue&type=script&lang=js&"
export * from "./langSwitch.vue?vue&type=script&lang=js&"
import style0 from "./langSwitch.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports